import { render } from "./profile_settings.vue?vue&type=template&id=a5c9ad32&scoped=true"
import script from "./profile_settings.js?vue&type=script&lang=js"
export * from "./profile_settings.js?vue&type=script&lang=js"

import "./profile_settings.vue?vue&type=style&index=0&id=a5c9ad32&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5c9ad32"]])

export default __exports__